<h4 class="dialog-title" mat-tialog-title>{{type}}</h4>
<mat-dialog-content class="dialog-body content-spacing">
  <p [innerHtml]="data.message">
  </p>
  <ul *ngIf="data.options">
    <li *ngFor="let option of data.options">{{option}}</li>
  </ul>
</mat-dialog-content>
<div [ngSwitch]="type">
  <div mat-dialog-actions *ngSwitchCase="'Confirmation'" align="end">
    <button (click)="OnAccept()" tsl-button color="blue" filled  size="medium">Yes</button>
    <button (click)="onNoClick()" tsl-button color="black" filled  size="medium">No</button>
  </div>
  <div mat-dialog-actions *ngSwitchDefault align="end">
    <button type="button" mat-raised-button color="accent" (click)="dialogRef.close()">OK</button>
  </div>
</div>